<template>
  <div class="container_leyenda" id="container_legenda" ref="leyenda">

    <!--Tabs header-->
    <ul class="nav nav-tabs nav-justified">
      <li class="nav-item">
        <a class="nav-link"
           @click.prevent="setActivo('capas')"
           :class="{ active: estaactivado('capas') }"
           href="#capas">
          <i class="fas fa-layer-group margin-rigth icobarralegenda"></i> Leyenda</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           @click.prevent="setActivo('reportes')"
           :class="{ active: estaactivado('reportes') }"
           href="#reportes">
          <i class="fas fa-chart-line icobarralegenda"></i> Reportes</a>
      </li>
    </ul>

    <!--Tabs content-->
    <div class="tab-content" id="myTabContent">

      <!--Leyendas content-->
      <div class="tab-pane fade" :class="{ 'active show': estaactivado('capas') }" id="capas">
        <Draggable :list="filters" ghost-class="moving-card" tag="ul" :animation="200" :move="onMoveDraggable"
                   @end="onEndDraggable">

          <li v-for="item in filters" :key="item.id" class="container_capas">
            <!--Type one (name and description)-->
            <div id="legend-1" class="container_leyenda_item" v-if="item.tipo_leyenda == 1">
              <div class="container_menu_opcion">
                <div class="title_opt_item_legenda">
                  <span>{{ item.nombre }}</span>
                </div>
                <div class="sugerencia" @click="onClickShowDialogFilter(item)">
                  <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="btn-close" @click="removeInFiltersAndDisableCheckboxInNav(item)">
                  <i class="fas fa-times"></i>
                </div>
              </div>
              <div class="sub_title_menu_item">
                <span>{{ item.descripcion }}</span>
              </div>
            </div>

            <!--Type two (name, description, date and quantity for FocoCalor)-->
            <div id="legend-2" class="container_leyenda_item" v-else-if="item.tipo_leyenda == 2">
              <div class="container_menu_opcion">
                <div>
                  <svg viewbox="0 0 20 20" height="20" width="20">
                    <circle :id="`circle_id_${item.id}`" cx="10" cy="10" r="6" :style="`fill:#${item.color}`"/>
                  </svg>
                </div>
                <div class="title_opt_item_legenda"><span>{{ item.nombre }}</span></div>
                <div class="sugerencia" @click="onClickShowDialogFilter(item)">
                  <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="btn-close" @click="removeInFiltersAndDisableCheckboxInNav(item)">
                  <i class="fas fa-times"></i>
                </div>
              </div>
              <div class="sub_title_menu_item"><span>{{ item.descripcion }}</span></div>
              <div class="imagenfocosleyenda">
                <div class="container_menu_opcion">
                  <div class="sugerencia">
                    <i class="item_icon fas fa-clock"></i>
                  </div>
                  <div :id="`date_initial_id_${item.id}`" class="fechasselecionadas"></div>
                </div>
                <div class="container_menu_opcion">
                  <div class="sugerencia">
                    <i class="item_icon fas fa-clock"></i>
                  </div>
                  <div :id="`date_final_id_${item.id}`" class="fechasselecionadas"></div>
                </div>
                <div class="container_menu_opcion">
                  <div class="sugerencia">
                    <i class="item_icon fas fa-fire"></i>
                  </div>
                  <div :id="`nro_id_${item.id}`" class="numerofocos"></div>
                </div>
                <div class="container_menu_opcion">
                  <div class="sugerencia">
                    <i class="item_icon fas fa-fire"></i>
                  </div>
                  <div :id="`nro_npp_id_${item.id}`" class="numerofocos"></div>
                </div>
                <div class="container_menu_opcion">
                  <div class="sugerencia">
                    <i class="item_icon fas fa-fire"></i>
                  </div>
                  <div :id="`nro_noa_id_${item.id}`" class="numerofocos"></div>
                </div>
                <div class="container_menu_opcion">
                  <div class="sugerencia">
                    <i class="item_icon fas fa-fire"></i>
                  </div>
                  <div :id="`nro_modis_id_${item.id}`" class="numerofocos"></div>
                </div>
              </div>
              <img src="../../../../assets/img-focos-legend.png"/>
            </div>

            <!--Type three (name, description and quantity)-->
            <div id="legend-3" class="container_leyenda_item" v-else-if="item.tipo_leyenda == 3">
              <div class="container_menu_opcion">
                <div>
                  <svg viewbox="0 0 20 20" height="20" width="20">
                    <circle :id="`circle_id_${item.id}`"
                            cx="10" cy="10" r="6" :fill="item.color"/>
                  </svg>
                </div>
                <div class="title_opt_item_legenda">
                  <span>{{ item.nombre }}</span>
                </div>
                <div class="sugerencia" @click="onClickShowDialogFilter(item)">
                  <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="btn-close" @click="removeInFiltersAndDisableCheckboxInNav(item)">
                  <i class="fas fa-times"></i>
                </div>
              </div>
              <div class="sub_title_menu_item">
                <span>{{ item.descripcion }}</span>
              </div>
            </div>

            <!--Type four (name, description and image)-->
            <div id="legend-4" class="container_leyenda_item" v-else>
              <div class="container_menu_opcion">
                <div class="title_opt_item_legenda">
                  <span>{{ item.nombre }}</span>
                </div>
                <div class="sugerencia" @click="onClickShowDialogFilter(item)">
                  <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="btn-close" @click="removeInFiltersAndDisableCheckboxInNav(item)">
                  <i class="fas fa-times"></i>
                </div>
              </div>
              <div class="sub_title_menu_item">
                <span>{{ item.descripcion }}</span>
              </div>
              <img src="../../../../assets/img-risk-legend.png" v-if="item.tipo_leyenda == 4"/>
              <img src="../../../../assets/img-biomass.png" v-else-if="item.tipo_leyenda == 5"/>
              <img src="../../../../assets/img-humidity.png" v-else-if="item.tipo_leyenda == 6"/>
              <img src="../../../../assets/img-precipitation.png" v-else-if="item.tipo_leyenda == 7"/>
              <img src="../../../../assets/img-temperature.png" v-else-if="item.tipo_leyenda == 8"/>
              <img src="../../../../assets/img-wind.png" v-else-if="item.tipo_leyenda == 9"/>
            </div>
          </li>
        </Draggable>
      </div>

      <!--Reportes content-->
      <div class="tab-pane fade" :class="{ 'active show': estaactivado('reportes') }" id="reportes">
        <!--Reportes content tab-->
        <div id="filters-reports" class="container">
          <p class="title-report">ANALISIS Y SEGUIMIENTO</p>
          <div class="filter-report">
            <div id="filter-departament" @click="selectFilterDepartament">
              <i class="fas fa-filter"></i>
              <div class="label-filter"><span>REPORTE POR FILTRO DE DATOS</span></div>
            </div>
            <div id="filter-draw" @click="selectFilterDraw">
              <i class="fas fa-draw-polygon"></i>
              <div class="label-filter"><span>REPORTE POR DIBUJO DE FIGURA</span></div>
            </div>
          </div>
          <div class="field">
            <label class="label label-report-select">Focos de calor seleccionado</label>
            <div class="control">
              <v-select
                  class="select-report"
                  label="nombre"
                  v-model="selectedFCFilter"
                  :options="fcFilters"
                  :clearable="false">
              </v-select>
            </div>
          </div>
          <div id="dpto-and-municipios" v-if="showReportForDepartamento">
            <form action="#" @submit.prevent="loadReport()">
              <div class="field">
                <label class="label label-report-select">Departamento</label>
                <div class="control">
                  <v-select
                      class="select-report"
                      label="nombre_departamento"
                      v-model="selectedDepartamento"
                      v-on:input="selectDepartamento()"
                      :options="departamentos"
                      :clearable="false">
                  </v-select>
                </div>
              </div>
              <div class="field">
                <label class="label label-report-select">Municipio</label>
                <div class="control">
                  <v-select
                      class="select-report"
                      label="nombre_municipio"
                      v-model="selectedMunicipio"
                      :options="municipios"
                      :clearable="false">
                  </v-select>
                </div>
              </div>
              <button class="btn btn-satrifo-succes">Generar reporte</button>
            </form>

          </div>
          <div id="dibujar-zona" v-if="showReportForDraw">
            <label class="label label-report-select">Dibujar sobre el mapa el área que desea analizar</label>
            <button class="btn btn-satrifo-succes" @click="loadReport()">Comenzar a dibujar</button>
          </div>
        </div>

        <div id="results-reports" style="display: none; padding: 10px;">
          <div id="results-reports-title" @click="setVisibleResultReport(false)" style="cursor: pointer; font-size: .875rem; color: #333; line-height: 1.1; font-weight: 500; margin-bottom: 10px;">
            <i class="fas fa-angle-left"></i> {{ titleReport }}
          </div>
          <div id="id_titulo_capa_selecionada">
            <div class="titulo_capaselecionada"></div>
          </div>
          <div id="descripcion_capa_calor">
            <div class="descripcion_capa_calor">{{ grafico_mensaje }}</div>
          </div>
          <div>
            <BarChart ref="refbarra"/>
          </div>

          <hr size="1px" color="black"/>

          <div id="listado_capa_calor">Listado de areas con mayor cantidad de focos de calor</div>
          <div id="listado_focos_calor">Listado de areas con mayor cantidad de focos de calor</div>
          <div id="listadosDeMunicipiosporCantidad">

            <div id="rptnonbredpto">
              <ul>
                <li v-for="(nombredpto, index) in rptdatanombredpt">
                  <template v-if="index + 1 == 1">
                    <div class="primerItemrpt">{{ index + 1 }}</div>
                  </template>
                  <template v-if="index + 1 == 2">
                    <div class="segundoItemrpt">{{ index + 1 }}</div>
                  </template>
                  <template v-if="index + 1 > 2">
                    <div class="treeItemrpt">{{ index + 1 }}</div>
                  </template>
                </li>
              </ul>
              <ul>
                <li v-for="nombremuni in rptdatarptnombremunicipio">
                  <div v-for="(nombredpto, index) in rptdatanombredpt">
                    <template v-if="index + 1 == 1">
                      {{ nombredpto }}
                    </template>
                  </div>
                  {{ nombremuni }}
                </li>
              </ul>
            </div>

            <div id="rptvalues">
              <ul>
                <li v-for="nombrevalue in rptdatavalues">{{ nombrevalue }}</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Tabs, Tab} from 'vue-tabs-component';
import {config} from '@/config.json'
import Draggable from 'vuedraggable';
import 'moment/locale/es';
import moment from 'moment';

Vue.component('tabs', Tabs);
Vue.component('tab', Tab);

import BarChart from "../../report/BarChart";
import Spinner from "vue-simple-spinner";
import vSelect from 'vue-select'
import jsonDepartamentosMunicipios from "@/helpers/departamentos-municipios.json";
import * as Utils from "@/helpers/utils.js";

Vue.component('v-select', vSelect);

import axios from "axios";
import {convertTZ} from "@/helpers/utils.js";

export default {
  name: "Legend",
  components: {
    BarChart,
    Spinner,
    Draggable
  },
  data() {
    return {
      filters: [],
      departamentos: [],
      municipios: [],
      fcFilters: [],

      showReportForDepartamento: false,
      showReportForDraw: false,

      selectedFCFilter: null,
      selectedDepartamento: null,
      selectedMunicipio: null,

      titleReport: "",
      activeItem: 'capas',

      grafico_mensaje: null,
      listadofocoscalor: null,
      rptdatanombredpt: [],
      rptdatarptnombremunicipio: [],
      rptdatavalues: [],

      movingIndex: -1,
      futureIndex: -1,
    }
  },
  methods: {
    setQuantityAndDate(filterId, quantity, quantityNpp, quantityNoa, initDate, finalDate) {
      //Quantity by legend.vue
      let divQuantity = document.getElementById(`nro_id_${filterId}`);
      divQuantity.innerHTML = '<b style="color:red;">' + `Cantidad de focos encontrados (${quantity})` + '</b>';

      //Quantity by legend.vue
      let divQuantityNpp = document.getElementById(`nro_npp_id_${filterId}`);
      divQuantityNpp.innerHTML = '<b style="color:black;">' + `Focos de calor para sensor NPP (${quantityNpp})` + '</b>';

      //Quantity by legend.vue
      let divQuantityNoa = document.getElementById(`nro_noa_id_${filterId}`);
      divQuantityNoa.innerHTML = '<b style="color:black;">' + `Focos de calor para sensor NOAA20 (${quantityNoa})` + '</b>';

      //Quantity by legend.vue
      let divQuantityModis = document.getElementById(`nro_modis_id_${filterId}`);
      divQuantityModis.innerHTML = '<b style="color:black;">' + `Focos de calor para sensor MODIS (${quantity - (quantityNoa + quantityNpp)})` + '</b>';

      //Date by legend.vue
      moment.locale('es')
      let initialDateStr = moment(initDate).format('DD [de] MMMM [de] YYYY HH:mm')
      let finalDateStr = moment(finalDate).format('DD [de] MMMM [de] YYYY HH:mm')

      let divDateInitial = document.getElementById(`date_initial_id_${filterId}`);
      divDateInitial.innerHTML = '<b>' + "Desde " + '</b>' + initialDateStr + ' - GMT-4';
      let divDateFinal = document.getElementById(`date_final_id_${filterId}`);
      divDateFinal.innerHTML = '<b>' + " Hasta " + '</b>' + finalDateStr + ' - GMT-4';
    },
    loadJsonDepartamentos() {
      return jsonDepartamentosMunicipios.filter(function (item) {
        return item.codigo_municipio === '0';
      });
    },
    loadJsonMunicipios(codigo_departamento) {
      return jsonDepartamentosMunicipios.filter(function (item) {
        return item.codigo_departamento === codigo_departamento && item.codigo_municipio > 0
      });
    },
    selectFilterDepartament() {
      const filterDepartament = document.querySelector("#filter-departament");
      const filterDraw = document.querySelector("#filter-draw");
      filterDepartament.classList.add('filter-report-active');
      filterDraw.classList.remove('filter-report-active');
      this.showReportForDepartamento = true;
      this.showReportForDraw = false;
    },
    selectFilterDraw() {
      const filterDepartament = document.querySelector("#filter-departament");
      const filterDraw = document.querySelector("#filter-draw");
      filterDepartament.classList.remove('filter-report-active');
      filterDraw.classList.add('filter-report-active');
      this.showReportForDepartamento = false;
      this.showReportForDraw = true;
    },
    selectDepartamento() {
      this.municipios = this.loadJsonMunicipios(this.selectedDepartamento.codigo_departamento);
      this.municipios.unshift({"codigo_municipio": "0", "nombre_municipio": "Todos"});
      this.selectedMunicipio = this.municipios[0];
    },
    loadReport() {
      if(this.selectedFCFilter === null) return;

      if (this.showReportForDepartamento) {
        if(this.selectedDepartamento !== null) {
          this.loadReportDepartamento();
        }
      } else {
        this.$root.$emit('map-draw-area-report', this.selectedFCFilter.fecha);
      }
    },
    loadReportDepartamento() {
      const self = this;
      const dateInit = Utils.formatDateTime(self.selectedFCFilter.init, "yyyy-MM-dd HH:mm:ss")
      const dateFinal = Utils.formatDateTime(self.selectedFCFilter.final, "yyyy-MM-dd HH:mm:ss")

      self.$root.$emit("app-show-loading", true);
      axios
          .get(`${config.api.baseURL}/rptFocosCalor/${dateInit}/${dateFinal}/${self.selectedDepartamento.codigo_departamento}/${self.selectedMunicipio.codigo_municipio}`)
          .then(function (response) {
            let data = JSON.parse(response.data.jsonCompleto);
            self.grafico_mensaje = data.grafico.msg;
            self.$refs.refbarra.loadData(data.grafico.labels, data.grafico.values, "Focos de calor por hora");

            self.titleReport = self.getTitleReport();
            self.listadofocoscalor = null;
            self.rptdatanombredpt = null;
            self.rptdatarptnombremunicipio = null;
            self.rptdatavalues = null;

            self.listadofocoscalor = data.reporte.msg;
            self.rptdatanombredpt = data.reporte.departamento;
            self.rptdatarptnombremunicipio = data.reporte.municipio;
            self.rptdatavalues = data.reporte.values;
            self.changeZoom(6);
          })
          .catch(err => {
            console.log("Legend:", err);
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
            self.setVisibleResultReport(true);
          });
    },
    loadReportDrawing(data) {
      const self = this;
      const fcMarkers = data.map(elem => ({
        "id": elem.id,
        "lat": elem.lat,
        "lng": elem.lng,
        "fechaInicial": Utils.formatDateTime(self.selectedFCFilter.init, "yyyy-MM-dd HH:mm:ss"),
        "fechaFinal": Utils.formatDateTime(self.selectedFCFilter.final, "yyyy-MM-dd HH:mm:ss")
      }));

      self.$root.$emit("app-show-loading", true);
      axios({
        method: 'post',
        url: `${config.api.baseURL}/rptFocosCalorPorGrafico`,
        data: Utils.toJSON(fcMarkers),
        headers: {'Content-Type': 'application/json;charset=UTF-8'}
      })
          .then(function (response) {
            let data = JSON.parse(response.data.jsonCompleto);
            self.grafico_mensaje = data.grafico.msg;
            self.$refs.refbarra.loadData(data.grafico.labels, data.grafico.values, "");

            self.titleReport = self.getTitleReport();
            self.listadofocoscalor = null;
            self.rptdatanombredpt = null;
            self.rptdatarptnombremunicipio = null;
            self.rptdatavalues = null;

            self.listadofocoscalor = data.reporte.msg;
            self.rptdatanombredpt = data.reporte.departamento;
            self.rptdatarptnombremunicipio = data.reporte.municipio;
            self.rptdatavalues = data.reporte.values;
            self.changeZoom(6);
          })
          .catch(err => {
            console.log("Legend:", err);
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
            self.setVisibleResultReport(true);
          });
    },
    setVisibleResultReport(visible) {
      document.getElementById('results-reports').style.display = visible? "block" : "none";
      document.getElementById('filters-reports').style.display = visible? "none" : "block";

      if (!visible && this.showReportForDraw) {
        this.$root.$emit("map-remove-polygone-report");
      }
    },
    getTitleReport() {
      if (this.selectedDepartamento === null) {
        return "Reporte de focos de calor";
      }

      if (this.selectedDepartamento.codigo_departamento === "0") {
        return "Todos";
      }

      let name = this.selectedDepartamento.nombre_departamento;

      if (this.selectedMunicipio !== null && this.selectedMunicipio.codigo_municipio !== "0") {
        name += " - " + this.selectedMunicipio.nombre_municipio;
      }
      return name;
    },
    estaactivado(menuItem) {
      return this.activeItem === menuItem
    },
    setActivo(menuItem) {
      this.activeItem = menuItem
    },
    addInFilters(filter) {
      this.filters.push(filter);
      this.fcFilters = this.filters.filter(it => {
        return it.categoria === "Focos de calor" && it.subcategoria === "Actual"
      });
    },
    removeInFilters(filter) {
      let cleanArray = [];
      this.filters.forEach(item => {
        if (item.id !== filter.id) {
          cleanArray.push(item);
        }
      });
      this.filters = cleanArray;
      this.fcFilters = this.filters.filter(it => {
        return it.categoria === "Focos de calor" && it.subcategoria === "Actual"
      });
      console.log(this.fcFilters)
    },
    removeInFiltersAndDisableCheckboxInNav(filter) {
      this.removeInFilters(filter);
      this.$root.$emit("nav-onclick-switch-disable", `switch_id_${filter.id}`, filter);
    },
    onClickShowDialogFilter(filter) {
      this.$root.$emit("nav-onclick-show-dialog-filter", filter, '', true);
    },
    onEndDraggable() {
      let futureItem = this.filters[this.futureIndex];
      this.$root.$emit("map-move-wms", futureItem, this.futureIndex);
    },
    onMoveDraggable(e) {
      const {index, futureIndex} = e.draggedContext;
      this.movingIndex = index;
      this.futureIndex = futureIndex;
    },
  },
  mounted() {
    this.departamentos = this.loadJsonDepartamentos();
    this.departamentos.unshift({"codigo_departamento": "0", "nombre_departamento": "Todos"});
  },
  created() {
    this.$root.$on('legend-add-in-filters', this.addInFilters);
    this.$root.$on('legend-remove-in-filters', this.removeInFilters);
    this.$root.$on('legend-set-quantity-date', this.setQuantityAndDate);
    this.$root.$on('legend-load-report-drawing', this.loadReportDrawing);
  },
  beforeDestroy() {
    this.$root.$off('legend-add-in-filters', this.addInFilters);
    this.$root.$off('legend-remove-in-filters', this.removeInFilters);
    this.$root.$off('legend-set-quantity-date', this.setQuantityAndDate);
    this.$root.$off('legend-load-report-drawing', this.loadReportDrawing);
  }
}

</script>

<style scoped lang="scss">
.container {
  padding: 20px 13px;
  width: 100%;
}

.box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.filter-report {
  display: flex;
  flex-direction: row;
  text-align: center;
  font-size: 1.5rem;
  color: #cccccc;
  margin-bottom: 10px;
}

.label-filter {
  text-align: center;
  line-height: 10px;
}

.filter-report #filter-departament {
  padding: 10px;
  margin: 15px;
  text-align: center;
  width: 100%;
  cursor: pointer;
}

.filter-report #filter-draw {
  padding: 10px;
  margin: 15px;
  text-align: center;
  width: 100%;
  cursor: pointer;
}

.filter-report #filter-departament:hover {
  color: #106129;
  border-bottom: 1px solid #106129;
}

.filter-report #filter-draw:hover {
  color: #106129;
  border-bottom: 1px solid #106129;
}

.filter-report #filter-departament span {
  font-size: 11px;
}

.filter-report #filter-draw span {
  font-size: 11px;
}

.filter-report-active {
  color: #106129;
  border-bottom: 1px solid #106129;
}

.select-report {
  margin: 0 auto;
  width: 100%;
  font-size: 12px;
  flex-wrap: inherit;
}

.label-report-select {
  text-align: left;
  font-size: 11px;
  font-weight: 500;
  color: #9e9e9e;
}

.title-report {
  font-size: 14px;
  font-weight: bold;
  color: #4a4a4a;
  text-align: center;
}

#container_capas {
  padding: 0;
  margin: 0;
  width: 100%;
}

#municipios_leyendas {
  margin: 0 auto;
  width: 100%;
}

.spinner-leyenda {
  z-index: 5000;
  opacity: 0.5;
  position: fixed;
  width: 95%;
  height: 100%;
  display: flex;
  align-items: center;
  top: 0;
}

.label-dibujar-poligono {
  text-align: center;
  margin-bottom: 1.25rem;
  font-size: 16px;
}

.listado_capa_calor {
  font-size: 0.85rem;
}

.btn-satrifo-succes {
  border-radius: 1.25rem;
  font-size: 14px;
  color: white;
  background: #106129;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 100%;
  width: 100%;
  height: 2.3rem;
}

.btn-satrifo-danger {
  border-radius: 1.25rem;
  font-size: 14px;
  color: white;
  background: #dc3545;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 100%;
  width: 100%;
  height: 2.3rem;
}

.icobarralegenda {
  color: #4c5e71;
}

.margin-rigth {
  margin-right: 5px;
}

.container_leyenda_item {
  padding: 10px;
  border-bottom: 1px solid rgb(229, 229, 229);
}

.container_leyenda {
  background: white;
  color: #212121;
  z-index: 5;
  position: absolute;
  left: 7rem;
  top: 0.9775rem;
  bottom: 0.9775rem;
  max-width: 18.125rem;
  width: 330px;
  box-shadow: 0 1px 3px 0;
  height: auto;
  display: flex;
  flex-direction: column;
}

.container_leyenda a {
  color: #4a4a4a !important;
  cursor: pointer;
}

.titulo_principal {
  font-size: 0.6875rem;
  color: #555;
  font-weight: bold;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.title_opt_item {
  font-size: 0.70rem;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin-left: 30px;
  color: #212121;
}

.sub_title_menu_item {
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -0.3px;
  color: #34495E;
  margin-top: 0.1875rem;
  max-width: calc(100% - 20px);
  width: 100%;
}

.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}

.titulo-legenda {
  color: #f2b257;
  text-align: left;
  font-size: 0.90rem;
  font-weight: bold;
  border-bottom: 1px solid #f2b257;
}

.circule {
  color: #f2b257;
  font-size: 0.70rem;
}

.tituto-principal {

}

.subtitle {
  font-size: 0.80rem;
  color: #b4b4b4;
  margin: 0px;
  padding: 0px;
}

.layer-close {
  height: 10px;
  width: 10px;
  background: white;
  font-size: 0.80rem;
}

a.circule-close {
  color: #aaaaaa;
}

.listaIconos {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.listaIconos li {
  float: left;
}

.contenedoriconos {
  text-align: center;
}


.tab-basemaps .maptype-list > li:first-child {
  border-top: none;
}

.tab-basemaps .maptype-list > li {
  position: relative;
  padding: 0 0 0 80px;
  border-top: 1px solid #e5e5df;
  cursor: pointer;
}

.tab-basemaps .maptype-list {
  max-height: 380px;
  overflow: auto;
}

.tab-basemaps .maptype-list > li .source {
  display: block;
  position: absolute;
  top: 50%;
  right: 20px;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  transform: translate(0, -50%);
}

.tab-basemaps .maptype-list > li.grayscale i {
  background-position: 0 -616px;
}

.basemaps-sprite, .tab-basemaps .maptype-list > li.grayscale i, .tab-basemaps .maptype-list > li.terrain i, .tab-basemaps .maptype-list > li.satellite i, .tab-basemaps .maptype-list > li.hybrid i, .tab-basemaps .maptype-list > li.treeheight i, .tab-basemaps .maptype-list > li.dark i, .tab-basemaps .maptype-list > li.positron i, .tab-basemaps .maptype-list > li.landsat i {
  background-position-x: 0%;
  background-position-y: 0%;
}

basemaps .maptype-list > li .source {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #97bd3d;
  position: relative;
}

.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background: #f1f1f1;
}

.select select {
  border-radius: 50px !important;
}

.select select:focus, .textarea:focus, .input:focus, .select select.is-focused, .is-focused.textarea, .is-focused.input, .select select:active, .textarea:active, .input:active, .select select.is-active, .is-active.textarea, .is-active.input {
  border-color: #555555;
  color: #8a8a9f;
  box-shadow: 0 0 0 0.1em #555555;
  border-radius: 35px;
}

select {
  color: #555555;
  background-color: white;
  padding: 10px;
  border: 1px solid #e5e5df;
  width: 246px !important;
  border-radius: 35px;
  height: 2em !important;
}

.select {
  width: 90%;
}

.select select {
  width: 100% !important;
  line-height: 0.5 !important;
}

.sugerencia {
  color: #34495E;
  width: 20px;
  margin-right: 5px;
  display: flex;
}

.btn-close {
  color: #34495E;
  cursor: pointer;
  width: 20px;
  display: flex;
}

.item_icon {
  margin: 0 auto;
}

.moving-card {
  @apply opacity-50 bg-gray-100 border border-blue-500;
}
.numerofocos{
  font-size: 12px;
  text-align: left;
  color: #34495E;
  line-height: 1.5;
  letter-spacing: -0.3px;
  width: 100%;
}
.fechasselecionadas{
  font-size: 12px;
  text-align: left;
  color: #34495E;
  line-height: 1.5;
  letter-spacing: -0.3px;
  width: 100%;
}
.descripcion_capa_calor{
  font-size: .7125rem;
  color:#333;
  line-height: 1.6;
  border-bottom: solid 1px #e5e5df;
  padding-bottom: .9375rem;
  margin-bottom: .9375rem;
}
.primerItemrpt{
  background: red none repeat scroll 0% 0%;
  color: white;
  border-radius: 50%;
  width: 30px;
  text-align: center;
  padding: 5px;
  height: 30px;
  font-size: 0.90rem;
  font-weight: 600;
}
.segundoItemrpt{
  background: #f0c005;
  color: white;
  border-radius: 50%;
  width: 30px;
  text-align: center;
  padding: 5px;
  height: 30px;
  font-size: 0.90rem;
  font-weight: 600;
  margin-top: 10px;
}
.treeItemrpt{
  background: #1a8016;
  color: white;
  border-radius: 50%;
  width: 30px;
  text-align: center;
  padding: 5px;
  height: 30px;
  font-size: 0.90rem;
  font-weight: 600;
  margin-top: 5px;
}
</style>